<template>
    <b-modal
        id="assignment-edit-add-shared-assignment-modal"
        :title="$t('portfolio.add_shared_assignment')"
        ok-only
        ok-variant="primary"
        :ok-title="$t('common.close')"
        size="xl"
        hide-footer
        @show="onshow"
        modal-class="apprentice-default-modal shared-assignment-modal"
        scrollable>
        <template v-slot:modal-header="{ close }">
            <h5 class="modal-title shared-assignment-modal-title">{{ $t('portfolio.add_shared_assignment') }}</h5>
            <b-button
                class="btn-shared-assignment-back btn-back"
                v-if="preview"
                size="sm"
                variant="outline-primary"
                @click="preview = !preview">
                {{ $t('portfolio.back_to_overview') }}
            </b-button>
            <b-button
                class="btn-shared-assignment-close close"
                @click="close()">
                x
            </b-button>
        </template>

        <div class="shared-assignments">
            <design-2021-portfolio-shared-assignments-component
                :education-levels-in="educationLevels"
                :assignments-in="assignments"
                :group-id-in="groupId"
                :portfolio-category-id-in="portfolioCategoryId"
                @update-preview-status="updatePreviewStatus"
                :is-loading="isLoading"
                :preview-in="preview"
                @add-assignment-to-list="addAssignmentToList">
            </design-2021-portfolio-shared-assignments-component>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-add-shared-assignment-modal-component',
    props: {
        courseId: Number,
        educationLevels: Array,
        groupId: Number,
        portfolioCategoryId: Number,
    },
    data() {
        return {
            assignments: [],
            assignment: {},
            sharedFilterAssignments: [],
            isLoading: false,
            preview: false,
        };
    },
    mounted() {
        this.getAssignments();
    },

    methods: {
        getAssignments() {
            this.isLoading = true;
            // todo atm we are loading everything, should be changed in the future
            axios.get(this.routes.getabAssignmentsByCourse()).then(
                (response) => {
                    if (response.data.length) {
                        this.assignments = response.data;
                        this.sharedFilterAssignments = this.assignments;
                    }
                    this.sort;
                    this.isLoading = false;
                },
                (error) => {
                    this.alert.ajaxError(error, this.$t('portfolio.error_retrieving_shared_exercises'));
                },
            );
        },

        onshow() {
            this.preview = false;
            this.getAssignments();
            this.assignment = {};
        },

        updatePreviewStatus(status) {
            this.preview = status;
        },

        addAssignmentToList(assignment) {
            this.$emit('add-assignment-to-list', assignment);
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .shared-assignment-modal {
    .modal-body,
    .modal-footer,
    .modal-header {
        background-color: $secondary-background-color;
    }

    .modal-header {
        padding-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .modal-title {
            align-self: center;
        }

        .btn-shared-assignment-back {
            margin-left: auto;

            & + .close {
                align-self: baseline;
            }
        }

        .close {
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.btn-shared-assignment-back {
    margin-left: auto;
    margin-right: map-get($grid-gutter-spacing, 'fifteen');
}

.btn-shared-assignment-close {
    padding: 5px 0 5px 5px;
    opacity: 0.5;

    &,
    &:hover {
        color: $text-color;
        border: none;
        box-shadow: none;
        outline: none;
        background-color: transparent;
    }

    &:hover {
        opacity: 0.75;
    }
}
</style>
